// export let baseurl = "https://api.ogcs.co.in";
// export let baseurl = "http://localhost:5000";
 

// src/config/url.js

const hostname = window.location.hostname;

const isLocal =
  hostname === "localhost" ||
  hostname === "127.0.0.1" ||
  hostname === "::1";

const LOCAL_API = "http://localhost:5000"; 
const PROD_API = "https://api.ogcs.co.in";    

export const baseurl = isLocal ? LOCAL_API : PROD_API;